import { toast } from "react-toastify";
import { PainelVendasFilterProps } from "../../../global/dataTransferObjects/transacoesTempoReal";

type ValueFilterInput = Pick<PainelVendasFilterProps, 'valueField' | 'valueOperator' | 'valueMin' | 'valueMax'>;

export const buildValueFilter = ({ valueField, valueOperator, valueMin, valueMax }: ValueFilterInput = {}) =>
  valueOperator
    ? { field: valueField ?? 'gross', operator: valueOperator, min: valueMin ?? null, max: valueMax ?? null }
    : null;

export const validateValueFilter = ({ valueOperator, valueMin, valueMax }: ValueFilterInput): boolean => {
  if (!valueOperator) return true;

  if ((valueOperator !== 'less' && valueMin == null) || (valueOperator !== 'greater' && valueMax == null)) {
    toast.error('Informe o valor para a comparação selecionada!');
    return false;
  }

  if (valueMin != null && valueMax != null && valueMax < valueMin) {
    toast.error('O valor máximo não pode ser menor que o valor mínimo!');
    return false;
  }

  return true;
};
